import BaseApi from '@/api/BaseApi'
import { appendRequestParameters } from '@/helpers/Utils'

/**
 * Environment settings.
 * @param {Object, Array, String, Null} params.users
 */

export default class OrganizationApi extends BaseApi {
    async getOrganizations (params = {
        name: null,
        email: null,
        phone: null,
        users: null,
        page: null,
        perPage: null,
        orderBy: null
    }) {
        const request = new URLSearchParams()

        if (params.page && params.perPage) {
            const skip = (params.page - 1) * params.perPage
            request.append('Skip', skip.toString())
            request.append('Take', params.perPage)
        }

        if (params.users) {
            appendRequestParameters('UserIds', request, params.users, 'id')
        }

        if (params.name) {
            request.append('Name', `%${params.name}%`)
        }

        if (params.email) {
            request.append('Email', `%${params.email}%`)
        }

        if (params.phone) {
            request.append('Phone', `%${params.phone}%`)
        }

        if (params.orderBy) {
            request.append('OrderBy', params.orderBy)
        }

        return this.get('/api/v1.0/organizations', request)
    }
    async getUserOrganizations (params = {
        page: null,
        perPage: null,
        orderBy: null
    }) {
        const request = new URLSearchParams()

        if (params.page && params.perPage) {
            const skip = (params.page - 1) * params.perPage
            request.append('Skip', skip.toString())
            request.append('Take', params.perPage)
        }

        if (params.orderBy) {
            request.append('OrderBy', params.orderBy)
        }

        return this.get('/api/v1.0/organizations/userOrganizations', request)
    }
    async getOrganizationById (organizationId) {
        return this.get(`/api/v1.0/organizations/${organizationId}`)
    }
    async getSubOrganizations (organizationId) {
        const request = new URLSearchParams()

        if (organizationId) {
            request.append('OrganizationId', organizationId)
        }
        return this.get(`/api/v1.0/organizations/subOrganizations`, request)
    }
    async createOrganization (params = {
        name: null,
        timeZone: null,
        supportEmail: null,
        supportPhoneNumber: null,
        isMainOrganization: false,
        licenses: null
    }) {
        return this.post(`/api/v1.0/organizations`, params)
    }
    async editOrganization (params = {
        id: null,
        name: null,
        timeZone: null,
        supportEmail: null,
        supportPhoneNumber: null,
        organizationBrandId: null,
        licenses: null
    }) {
        return this.put('/api/v1.0/organizations', params)
    }
    async deleteOrganizationById (organizationId) {
        return this.delete(`/api/v1.0/organizations/${organizationId}`)
    }

    async move (organizations) {
        return this.post(`/api/v1.0/organizations/move`, {
            organizationId: organizations
        })
    }
}
